import React from "react"
import styles from "./styles.scss"
import image from "images/esen-laptop.png"
import MenuBar from "components/MenuBar"

class Hero extends React.Component {
  render() {
    return (
      <header className={styles.container}>
        <MenuBar />
        <div className={styles.wrapper}>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>
              Utvalda <br />
              Case Studies
            </h1>
            <p className={styles.description}>
              Här hittar du ett urval av case studies
              <br />
              från några av våra tidigare utförda projekt.
            </p>
          </div>
          <div className={styles.imageContainer}>
            <img
              src={image}
              alt="Laptop som visar en turneringsplattform som utvecklats av SAITS"
              className={styles.image}
            />
          </div>
        </div>
      </header>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/pages/CaseStudiesPage/Hero/index.jsx